
export enum InvoiceStatus {
  DRAFT = "DRAFT",
  READY = "READY",
  PAYMENT_PENDING = "PAYMENT_PENDING",
  PAID = "PAID",
}
